import { Component } from 'react';
import { connect } from 'react-redux';
import Datatable from '../../../common/datatable';
import { downloadPipEposDataMissingReport, downloadPipEposDataErrorsReport } from '../../../../actions/pip-epos-data';

const eposSubmissionErrors = 'EPOS Submission Errors';
const missingEpos = 'Missing EPOS';
const modePriceFluctuations = 'Mode Price Fluctuations';

class PipEposSubmissionsReport extends Component {
  render() {
    const { startDate, endDate, dispatch } = this.props;
    const columns = [
      {
        prop: 'report',
        title: 'Report'
      }
    ];
    const actions = [
      {
        label: 'Download',
        callback: (row) => {
          switch (row.report) {
            case eposSubmissionErrors:
              dispatch(downloadPipEposDataErrorsReport(startDate, endDate));

              break;
            case missingEpos:
              dispatch(downloadPipEposDataMissingReport(startDate, endDate));

              break;
            default:
              break;
          }
        },
        disabled: row => row.report === modePriceFluctuations
      }
    ];
    const data = [
      {
        report: eposSubmissionErrors
      },
      {
        report: missingEpos
      },
      {
        report: modePriceFluctuations
      }
    ];

    return (
      <div>
        <div className="mg-bottom-30"></div>
        <Datatable
          hideId
          hasAttributes={false}
          data={data}
          columns={columns}
          actions={actions}
        />
      </div>
    );
  }
}

export default connect(null)(PipEposSubmissionsReport);
